import React from "react";
import { useLang } from "@/i18n/LanguageContext";
import { MessageCircle, ShoppingCart } from "lucide-react";
import BookingDialog from "@/components/BookingDialog";

const fmt = (n) => new Intl.NumberFormat("id-ID").format(Math.round(n));

export default function StickyMobileCTA({ pkg, price, roomLabel }) {
  const { lang } = useLang();
  const t = (id, en) => (lang === "id" ? id : en);
  const name = lang === "id" ? pkg.name_id : pkg.name_en;
  const waMessage = encodeURIComponent(`Halo BATIK, saya tertarik dengan ${name} — ${roomLabel || ""}`.trim());

  return (
    <div
      data-testid="sticky-mobile-cta"
      className="fixed bottom-0 inset-x-0 z-40 md:hidden bg-white/95 backdrop-blur-md border-t border-border shadow-[0_-4px_20px_rgba(0,0,0,0.08)]"
    >
      <div className="px-4 py-3 flex items-center justify-between gap-3">
        <div className="flex-1 min-w-0">
          <p className="text-[10px] uppercase tracking-widest text-muted-foreground truncate">
            {roomLabel || t("Harga mulai", "Starting from")}
          </p>
          <p className="font-serif text-lg text-primary truncate">
            {price > 0 ? `Rp ${fmt(price)}` : t("Hubungi Kami", "Contact Us")}
          </p>
        </div>
        <div className="flex gap-2 shrink-0">
          <a
            href={`https://wa.me/6282114294101?text=${waMessage}`}
            target="_blank" rel="noopener noreferrer"
            data-testid="sticky-wa-btn"
            className="h-11 w-11 rounded-full bg-emerald-600 hover:bg-emerald-700 text-white grid place-items-center transition-colors"
            aria-label={t("Tanya via WA", "Ask via WhatsApp")}
          >
            <MessageCircle className="h-5 w-5" />
          </a>
          <BookingDialog pkg={pkg}>
            <button
              data-testid="sticky-book-btn"
              className="inline-flex items-center gap-1.5 h-11 px-5 rounded-full bg-primary text-primary-foreground text-sm font-semibold hover:bg-primary/90 transition-colors"
            >
              <ShoppingCart className="h-4 w-4" />
              {t("Daftar", "Book")}
            </button>
          </BookingDialog>
        </div>
      </div>
    </div>
  );
}
